import React from "react";

import { Button, Modal } from "antd";

export default function ModalConfirm({
    title = "Confirm",
    text = "Are you sure you want to execute this action?",
    visible,
    onOk,
    onCancel,
    loading,
}) {
    return (
        <Modal
            className="arbo-modal"
            title={title}
            open={visible}
            onOk={onOk}
            onCancel={onCancel}
            footer={[
                <Button key="submit" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button key={1} type="primary" loading={loading} onClick={onOk}>
                    OK
                </Button>,
            ]}
        >
            <div>{text}</div>
        </Modal>
    );
}
